module.exports = __webpack_public_path__ + "img/fogg-waiting-2.dc94b20a.png";